module.exports = __webpack_public_path__ + "img/tree-3.829d6c94.png";